module.exports = __webpack_public_path__ + "static/img/blbd-img4.1cddc300.png";